import OpenAI from 'openai';

/**
 * Initializes the OpenAI client with the API key from environment variables.
 * @returns {OpenAI} Configured OpenAI client instance.
 */
const openai = new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true, // Required for client-side usage in React
  maxRetries: 3, // Built-in retry mechanism from OpenAI SDK
  timeout: 60000, // 60 second timeout for long-running requests
});

export default openai;